import { ApolloProvider } from '@apollo/client';
import { IPropsWithChildren } from '@omaze/app';
import { CosmicPageClientProvider } from '@omaze/cms';
import React, { Fragment, FunctionComponent, ReactElement } from 'react';

import { shopifyClient } from '../../data-sources/shopify-client/shopifyClient';
import { Portal } from '../../shared/Portal/Portal.component';

import { CuratedCollections } from './CuratedCollections/CuratedCollections';
import { FeaturedAdList } from './FeaturedAdList/FeaturedAdList';

export interface IHomepageAppProps {
    StorefrontProvider?: FunctionComponent<IPropsWithChildren>;
    PageFetcherProvider?: FunctionComponent<IPropsWithChildren>;
}

export function DefaultStorefrontProvider (props: IPropsWithChildren): ReactElement {
    return (
        <ApolloProvider client={shopifyClient}>
            {props.children}
        </ApolloProvider>
    );
}

export function DefaultCosmicProvider (props: IPropsWithChildren): ReactElement {
    return (
        <CosmicPageClientProvider bucket={window.ozShopifyApp.dataSources.cosmic.bucket}>
            {props.children}
        </CosmicPageClientProvider>
    );
}

export function Homepage (props: IHomepageAppProps): ReactElement {
    const {
        StorefrontProvider = DefaultStorefrontProvider,
        PageFetcherProvider = DefaultCosmicProvider,
    }: IHomepageAppProps = props;

    return (
        <Fragment>
            <StorefrontProvider>
                <Portal el="homepage-app__curated-collections">
                    <CuratedCollections />
                </Portal>
            </StorefrontProvider>
            <PageFetcherProvider>
                <Portal el="homepage-app__featured-ad">
                    <FeaturedAdList />
                </Portal>
            </PageFetcherProvider>
        </Fragment>
    );
}
